export default __webpack_public_path__ + "static/media/Levitate D6.4 Long-term Impacts of CCAM on Passenger Transport.a5921c18.pdf";